import React, { useEffect } from 'react'
import { RouteChildrenProps } from 'react-router'

import styles from './styles.sass'
import { observer } from 'mobx-react'
import { ConfirmEmailViewModel } from './ConfirmEmailViewModel'
import EmailConfirmationScreen from '../components/EmailConfirmationScreen/EmailConfirmationScreen'

interface Props extends RouteChildrenProps {
  vm: ConfirmEmailViewModel
}

export default observer(function EmailConfirmationPage({ vm }: Props) {
  const qs = new URLSearchParams(location.search)

  const token = qs.get('session_token') ?? ''

  useEffect(() => {
    vm.activate(token)
  }, [vm])

  return (
    <EmailConfirmationScreen>
      <div className={styles.title}>
        {!vm.pageExpired ? (
          <>Check your inbox and verify your email address</>
        ) : (
          <>This page has expired</>
        )}
      </div>
      <div className={styles.description}>
        {!vm.pageExpired ? (
          <>
            We've sent a confirmation link to <b>{vm.email}</b>.
          </>
        ) : (
          <>Please log in again.</>
        )}
      </div>
      {!vm.pageExpired && (
        <div className={styles.help}>
          <div className={styles.helpTitle}>Didn't receive the email?</div>
          <p>
            Check your spam folder or{' '}
            <b>
              <a
                className={styles.resendEmail}
                onClick={vm.resendVerificationEmail}
              >
                send the email again.
              </a>
            </b>
          </p>
        </div>
      )}
    </EmailConfirmationScreen>
  )
})
